import { API_URL } from '../constants';
import { postTimetableRequest } from 'src/utils/timetables/postTimetableRequest';
import { ITimetable } from '../getTimetables';
import { IDuplicateTimetableRequestBody } from './types';

export const duplicateTimetable = (
  timetableId: string,
  requestBody: IDuplicateTimetableRequestBody,
): Promise<ITimetable> =>
  postTimetableRequest<ITimetable>(
    `${API_URL}/timetables/${timetableId}/duplicate`,
    JSON.stringify(requestBody),
    'Could not duplicate timetable',
  );
